var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gamebox",attrs:{"id":"id"}},[_c('Navigation',{attrs:{"browse":_vm.browse}}),_vm._v(" "),_c('main',[_c('div',{staticClass:"wrap"},[_c('router-view',{attrs:{"main":_vm.main,"browse":_vm.browse}})],1),_vm._v(" "),_c('DetailModal')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78075b6a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/GameBox.vue
// module id = 2038
// module chunks = 0